import React, { useCallback, useState } from 'react'
import ShopHeader from '../components/ShopHeader'
import { NavLink, useNavigate } from 'react-router-dom';
import '../styles/Buy.css'
import mailIcon from '../icons/mail.png'
import tgIcon from '../icons/tg.png'
import constants from '../config/consts';
import dstimg from '../images/devushka_s_telefonom.png'
import nazad from '../icons/nazad.svg'
import { useWishlistContext } from '../context/WishlistContext';
import likeIcon from '../icons/like.svg';

import Cookies from 'js-cookie';
import API from '../api/MainApi';
import WishlistModal from '../components/WishlistModal';

const Buy = () => {
    const WISHLIST_COOKIE = 'wishlist';
    const navigate = useNavigate();

    const [showWishlist, setShowWishlist] = useState(false);
    const { products: wishlistItems, loading: wishlistLoading, removeItem, total } = useWishlistContext();

    const getItemsFromCookie = useCallback(() => {
        const cookie = Cookies.get(WISHLIST_COOKIE);
        return cookie ? JSON.parse(cookie) : [];
    }, []);

    let positions = getItemsFromCookie();
    

    const handleTgClick = async () => {
        
        await API.createClientOrder(positions).then(async (res) => {
            const getFormatedPositions = (poses) => {
                let formatedText = ''
                for(const pos of poses){
                    formatedText += pos.title
                    formatedText += ' | Кол-во: '
                    formatedText += pos.quantity
                    formatedText += ' | Цена: '
                    formatedText += pos.price
                    formatedText += ' | ID: '
                    formatedText += pos.productId
                    formatedText += '\n'
                }
                return formatedText
            }
            const message = await encodeURIComponent(`Здравствуйте, Екатерина👋\n\nМой вишлист:\n${await getFormatedPositions(res.data.FP)}\nСумма: ${res.data.CT}\nНомер заказа: ${res.data.orderId}`)
            window.location.href = `tg://resolve?domain=${constants.TG_USER_NAME}&text=${message}`;
        })

    }

    const handleMailClick = async () => {
        
        await API.createClientOrder(positions).then(async (res) => {
            const getFormatedPositions = (poses) => {
                let formatedText = ''
                for(const pos of poses){
                    formatedText += pos.title
                    formatedText += ' | Кол-во: '
                    formatedText += pos.quantity
                    formatedText += ' | Цена: '
                    formatedText += pos.price
                    formatedText += ' | ID: '
                    formatedText += pos.productId
                    formatedText += '\n'
                }
                return formatedText
            }
            const message = await encodeURIComponent(`Здравствуйте, Екатерина👋\n\nМой вишлист:\n${await getFormatedPositions(res.data.FP)}\nСумма: ${res.data.CT}\nНомер заказа: ${res.data.orderId}`)
            window.location.href = `mailto:${constants.MAIL_TO}?subject=Новый заказ&body=${message}`;
        })
    }


  return (
    <section className="Buy">
        <ShopHeader />
        <div className="buyInfoContent">
            <div className="buyText">
                <p>Настенные обои с моими рисунками можно купить в магазине</p>
                <h3 onClick={() => window.location.href = 'https://funhousestore.ru/oboi/f/hudozhnik-ekaterina_shumkova/'}>FUNHOUSE STORE</h3>
            <p>По вопросам приобретения фигурок и других предметов можете написать мне 
в <span onClick={() => window.location.href = `tg://resolve?domain=${constants.TG_USER_NAME}`}>Telegram</span>, <span onClick={() => window.location.href = 'https://facebook.com/katia.shumkova'}>Facebook</span> и на <span onClick={() => window.location.href = `mailto:${constants.MAIL_TO}?subject=Вопрос&body=Здравствуйте, Екатерина👋`}>электронную почту</span>.</p>
            </div> 
            {positions?.length > 0 ? <h3>Поделится вишлистом:</h3> : null}
            {positions?.length > 0 ? <div className="buySendButtons">
                <span className="buyButtonBlock" onClick={() => handleMailClick()}>
                    <img src={mailIcon} alt="Поделится по почте"/>
                </span>
                <span className="buyButtonBlock bbb2" onClick={() => handleTgClick()}>
                    <img src={tgIcon} alt="Поделится по telegram"/>
                </span>
            </div> : null }
            <NavLink className={'aboutGoBack dontshow'} to="/"> <img src={nazad} alt="Назад" className='aboutGoBackImg' /> </NavLink>
        </div>
        <img src={dstimg} alt="Девушка с телефоном" className='buyBottomImage' />
        <button className="wishlistFloatingButton" onClick={() => setShowWishlist(true)}>
                <img src={likeIcon} alt="Избранное" />
                {wishlistItems.length > 0 && <span className="wishlistCount">{wishlistItems.length}</span>}
            </button>

            {showWishlist && (
                <WishlistModal
                    items={wishlistItems}
                    loading={wishlistLoading}
                    total={total}
                    onClose={() => setShowWishlist(false)}
                    onRemove={removeItem}
                />
            )}
    </section>
  )
}

export default Buy